import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "../../services/api";
import Logo from "../../assets/logo.png";

const ResetPassword = () => {
  const [nouveauMotDePasse, setNouveauMotDePasse] = useState("");
  const [confirmer, setConfirmer] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (nouveauMotDePasse.length < 6) {
      return setError("Le mot de passe doit contenir au moins 6 caractères");
    }
    if (nouveauMotDePasse !== confirmer) {
      return setError("Les mots de passe ne correspondent pas");
    }

    setLoading(true);
    try {
      await api.post("/auth/reinitialiser-mdp", {
        token,
        nouveau_mot_de_passe: nouveauMotDePasse
      });
      setMessage("Mot de passe réinitialisé avec succès !");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.response?.data?.error || "Lien invalide ou expiré");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "1rem" }}>
        <p style={{ color: "#dc2626" }}>Lien invalide ou expiré.</p>
        <Link to="/login" style={{ color: "#2563eb" }}>Retour à la connexion</Link>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh", backgroundColor: "white",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      padding: "2rem"
    }}>
      <img src={Logo} alt="Banque Bleue" style={{ width: "80px", marginBottom: "1.5rem" }} />

      <h2 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#1f2937", marginBottom: "0.5rem" }}>
        Nouveau mot de passe
      </h2>
      <p style={{ fontSize: "0.9rem", color: "#6b7280", marginBottom: "1.5rem", textAlign: "center" }}>
        Choisissez un nouveau mot de passe sécurisé.
      </p>

      {message && (
        <div style={{
          width: "100%", maxWidth: "380px", marginBottom: "1rem",
          padding: "0.75rem", backgroundColor: "#f0fdf4",
          border: "1px solid #86efac", borderRadius: "0.5rem",
          color: "#16a34a", fontSize: "0.875rem"
        }}>
          {message} Redirection...
        </div>
      )}

      {error && (
        <div style={{
          width: "100%", maxWidth: "380px", marginBottom: "1rem",
          padding: "0.75rem", backgroundColor: "#fef2f2",
          border: "1px solid #fecaca", borderRadius: "0.5rem",
          color: "#dc2626", fontSize: "0.875rem"
        }}>
          {error}
        </div>
      )}

      {!message && (
        <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "380px" }}>
          {/* Nouveau mot de passe */}
          <div style={{ position: "relative", marginBottom: "1rem" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={nouveauMotDePasse}
              onChange={(e) => setNouveauMotDePasse(e.target.value)}
              placeholder="Nouveau mot de passe"
              required
              style={{
                width: "100%", padding: "0.75rem 3rem 0.75rem 1rem",
                border: "1px solid #d1d5db", borderRadius: "0.5rem",
                fontSize: "1rem", color: "#374151", outline: "none",
                boxSizing: "border-box", background: "white"
              }}
            />
            <button type="button" onClick={() => setShowPassword(!showPassword)}
              style={{ position: "absolute", right: "1rem", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9ca3af", padding: 0 }}>
              <svg xmlns="http://www.w3.org/2000/svg" style={{ width: "1.25rem", height: "1.25rem" }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </button>
          </div>

          {/* Confirmer */}
          <input
            type={showPassword ? "text" : "password"}
            value={confirmer}
            onChange={(e) => setConfirmer(e.target.value)}
            placeholder="Confirmer le mot de passe"
            required
            style={{
              width: "100%", padding: "0.75rem 1rem",
              border: "1px solid #d1d5db", borderRadius: "0.5rem",
              fontSize: "1rem", color: "#374151", outline: "none",
              marginBottom: "1.5rem", boxSizing: "border-box", background: "white"
            }}
          />

          <button type="submit" disabled={loading}
            style={{
              width: "100%", padding: "0.85rem",
              background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
              color: "white", fontWeight: 700, fontSize: "1rem",
              borderRadius: "9999px", border: "none",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              boxShadow: "0 4px 14px rgba(37,99,235,0.4)"
            }}>
            {loading ? "Réinitialisation..." : "Réinitialiser"}
          </button>
        </form>
      )}

      <Link to="/login" style={{ marginTop: "1.5rem", fontSize: "0.875rem", color: "#6b7280", textDecoration: "none" }}>
        ← Retour à la connexion
      </Link>
    </div>
  );
};

export default ResetPassword;